// Buduje kanoniczny URL modelu. ID na końcu jest jedynym źródłem prawdy
// (patrz parsowanie w ModelDetails.jsx) — slug to wyłącznie dekoracja SEO
// i ma pochodzić z API. Front nie definiuje własnych reguł slugify: jeśli
// API nie zwraca jeszcze pola slug, link spada do samego ID.
export const buildModelUrl = (category, model) => {
  if (!model || model.id == null) return null;
  return model.slug ? `/model/${category}/${model.slug}-${model.id}` : `/model/${category}/${model.id}`;
};
